module.exports = __webpack_public_path__ + "static/media/Framing Effect - pine-watt-pF3BfaLGhqw-unsplash.3b9621a6.jpg";